import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
  selector: 'app-radar-loader',
  standalone: true,
  imports: [],
  templateUrl: './radar-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './radar-loader.component.scss'
})
export class RadarLoaderComponent {
	@Input() scale = 1;
}
